module.exports = __webpack_public_path__ + "img/p2-28.afd303fa.png";